(function() {
  'use strict';

  // Global functions to handle Cart Drawer
  window.pepalOpenCartDrawer = function() {
    const backdrop = document.getElementById('CartDrawerBackdrop');
    const drawer = document.getElementById('CartDrawer');
    if (backdrop) backdrop.classList.add('is-open');
    if (drawer) drawer.classList.add('is-open');
    document.body.classList.add('cart-drawer-open');
  };

  window.pepalCloseCartDrawer = function() {
    const backdrop = document.getElementById('CartDrawerBackdrop');
    const drawer = document.getElementById('CartDrawer');
    if (backdrop) backdrop.classList.remove('is-open');
    if (drawer) drawer.classList.remove('is-open');
    document.body.classList.remove('cart-drawer-open');
  };

  window.pepalUpdateCartDrawer = function(openAfter = true) {
    const loading = document.getElementById('CartDrawerLoading');
    if (loading) loading.classList.add('is-active');

    fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
      .then(response => response.text())
      .then(html => {
        // Parse the new HTML
        const parser = new DOMParser();
        const newDocument = parser.parseFromString(html, 'text/html');
        const newInner = newDocument.getElementById('cart-drawer-inner');
        
        // Replace existing
        const currentInner = document.getElementById('cart-drawer-inner');
        if (currentInner && newInner) {
          currentInner.innerHTML = newInner.innerHTML;
        }

        // Also update header cart count if present
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(r => r.json())
          .then(cart => {
            const countEls = document.querySelectorAll('[data-cart-count]');
            countEls.forEach(el => {
              el.textContent = cart.item_count;
              el.style.display = cart.item_count > 0 ? 'flex' : 'none';
            });
          });

        if (openAfter) {
          window.pepalOpenCartDrawer();
        }
      })
      .catch(err => console.error('Failed to update cart drawer', err));
  };

  window.pepalChangeItem = function(key, qty) {
    const loading = document.getElementById('CartDrawerLoading');
    if (loading) loading.classList.add('is-active');

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: qty
      })
    })
    .then(response => response.json())
    .then(data => {
      window.pepalUpdateCartDrawer(true);
    })
    .catch(error => {
      console.error('Error updating cart', error);
      if (loading) loading.classList.remove('is-active');
    });
  };

  // Bind cart toggles
  function bindCartToggles() {
    document.querySelectorAll('[data-open-cart]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        window.pepalOpenCartDrawer();
      });
    });
  }

  // Intercept Add to Cart forms on the product page
  function interceptAddToCart() {
    document.querySelectorAll('form[action="/cart/add"], form[data-type="add-to-cart-form"]').forEach(form => {
      // Store original submit button text before binding
      const submitBtn = form.querySelector('[name="add"], button[type="submit"]');
      if (submitBtn) {
        submitBtn.setAttribute('data-original-text', submitBtn.innerHTML);
      }

      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const btn = form.querySelector('[name="add"], button[type="submit"]');
        const originalText = btn ? btn.getAttribute('data-original-text') || btn.innerHTML : '';
        if (btn) {
          btn.disabled = true;
          btn.innerHTML = 'Adding...';
        }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: new FormData(form)
        })
        .then(r => {
          if (!r.ok) throw new Error('Failed to add to cart');
          return r.json();
        })
        .then(() => {
          if (btn) {
            btn.innerHTML = 'Added!';
            setTimeout(() => {
              btn.innerHTML = originalText;
              btn.disabled = false;
            }, 2000);
          }
          window.pepalUpdateCartDrawer(true);
        })
        .catch(err => {
          console.error('Add to cart error:', err);
          if (btn) {
            btn.innerHTML = originalText;
            btn.disabled = false;
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindCartToggles();
    interceptAddToCart();
  });

})();
